export const environment = {
  production: true,
  apiUrl: 'https://api.pestforceapp.com',
  documentStorageUrl: 'https://pestware-storage-devs.s3.amazonaws.com/',
};
